import { useEffect } from "react";
import APIS from "../../constant/EndPoint";
import Modal from "../Reusable/Modal";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TimeField from "../Reusable/TimeField/TimeField";
import NumberField from "../Reusable/NumberField";
import CreateStaff from "../../pages/Staff/CreateStaff";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import LocationPicker from "../../components/Reusable/Map/LocationPicker";

const StaffForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  watch,
  setOpenUserFormPopup,
  openUserFormPopup,
  isEdit,
}: any) => {
  const isRest = watch("is_rest");
  const navigate = useNavigate();
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);


  const lat = watch("latitude");
  const lng = watch("longitude");
  const locationName = watch("location_name");

  useEffect(() => {

    if (!locationName || locationName.length < 4) return;

    const delayDebounceFn = setTimeout(async () => {
      setIsSearching(true);
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(locationName)}&limit=1`
        );
        const data = await response.json();

        if (data && data.length > 0) {
          const newLat = parseFloat(data[0].lat);
          const newLon = parseFloat(data[0].lon);
          setValue("latitude", newLat, { shouldValidate: true });
          setValue("longitude", newLon, { shouldValidate: true });
          clearErrors(["latitude", "longitude"]);
        }
      } catch (error) {
        console.error("Geocoding failed:", error);
      } finally {
        setIsSearching(false);
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [locationName, setValue, clearErrors]);

  const fetchLocationName = async (latitude: number, longitude: number) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
      );
      const data = await response.json();
      if (data.display_name) {
        setValue("location_name", data.display_name);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const handleGpsSync = (latitude: number, longitude: number) => {
    setValue("latitude", latitude, { shouldValidate: true });
    setValue("longitude", longitude, { shouldValidate: true });
    clearErrors(["latitude", "longitude"]);
    fetchLocationName(latitude, longitude);
  };


  return (
    <>
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        {/* User Selection */}
        {!isEdit ? (
          <div className={tw`w-full flex items-start justify-center space-x-1`}>
            <div className={tw`w-full`}>
              <ComboboxInput
                url={APIS.USER}
                queryKey={"users"}
                register={register("user")}
                errors={errors?.user}
                name={"user"}
                label={"Assign User"}
                setValue={setValue}
                props={{ is_active: true, is_staff: true }}
                placeholder={"Search user"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <div className={tw`-mt-2`}>
              <button
                className={tw`border px-4 py-1 text-xl relative top-9 bg-[#EEF5F4] focus:outline-none`}
                type="button"
                onClick={() => setOpenUserFormPopup(true)}
              >
                +
              </button>
            </div>
          </div>
        ) : (

          <div className={tw`w-full bg-gray-50 p-3 rounded border border-dashed`}>
            <p className={tw`text-xs text-gray-500`}>Assigned User </p>
            <p className={tw`font-semibold`}>{getValues("user_name") || "Existing Staff"}</p>
          </div>
        )}

        {/* Location Name Field */}
        <TextField
          label={`Location ${isSearching ? "(Searching...)" : ""}`}
          register={register("location_name")}
          errors={errors?.location_name}
          placeholder="Location"
        />

        {/* Latitude and Longitude */}
        <NumberField
          register={register("latitude")}
          errors={errors?.latitude}
          label={"Latitude"}
          value={lat}
          setValue={setValue}
          clearErrors={clearErrors}
        />
        <NumberField
          register={register("longitude")}
          errors={errors?.longitude}
          label={"Longitude"}
          value={lng}
          setValue={setValue}
          clearErrors={clearErrors}
        />

        {/* Radius and Graces */}
        <NumberField
          register={register("radius_meters")}
          errors={errors?.radius_meters}
          label={"CheckIn/Out Radius"}
          value={getValues("radius_meters")}
          setValue={setValue}
          clearErrors={clearErrors}
        />
        <TextField label={"CheckIn Grace"} register={register("checkin_grace")} errors={errors?.checkin_grace} />
        <TextField label={"CheckOut Grace"} register={register("checkout_grace")} errors={errors?.checkout_grace} />

        {/* Shift Selection */}
        <ComboboxInput
          url={APIS.SHIFT}
          queryKey={"shift"}
          register={register("shift")}
          errors={errors?.shift}
          name={"shift"}
          label={"Shift"}
          setValue={setValue}
          placeholder={"Search Shift"}
          getValues={getValues}
          clearErrors={clearErrors}
        />

        {/* Map Preview Section */}
        <div className={tw`mt-4 col-span-2 md:col-span-1`}>
          <div className={tw`flex justify-between items-center mb-1`}>
            <label className={tw`block text-xs font-semibold text-gray-700`}>Map Preview</label>
            <button
              type="button"
              onClick={() => setIsMapOpen(true)}
              className={tw`text-[10px] bg-blue-50 text-blue-600 border border-blue-200 px-2 py-0.5 rounded shadow-sm hover:bg-blue-100 transition-all`}
            >
              + Full Map
            </button>
          </div>
          <div className={tw`h-[250px] w-full border rounded shadow-sm overflow-hidden cursor-pointer`} >
            <LocationPicker
              height={250}
              initialPos={lat && lng ? [Number(lat), Number(lng)] : null}
              onLocationSelect={handleGpsSync}
            />
          </div>
        </div>
      </div>

      <Modal title={"Select Location"} isOpen={isMapOpen} setIsOpen={setIsMapOpen}>
        <div className={tw`w-full h-[450px] mt-2 rounded overflow-hidden border`}>
          <LocationPicker
            height={450}
            initialPos={lat && lng ? [Number(lat), Number(lng)] : null}
            onLocationSelect={handleGpsSync}
          />
        </div>
      </Modal>

      <Modal title={"Create Staff"} isOpen={openUserFormPopup} setIsOpen={setOpenUserFormPopup}>
        <CreateStaff setOpenUserFormPopup={setOpenUserFormPopup} openUserFormPopup={openUserFormPopup} />
      </Modal>
    </>
  );
};

export default StaffForm;